import React from 'react';
import store from 'store2';
import { Button, Menu, Tooltip, Typography } from 'antd';
import {
  BankOutlined,
  LogoutOutlined,
  PlusSquareOutlined,
  SlidersOutlined,
  TeamOutlined,
  UserOutlined,
  WalletOutlined,
} from '@ant-design/icons';
import { useHistory, useLocation } from 'react-router-dom';

// The navigation, in menu order. `path` is both the route the item opens and the prefix that marks it
// active (`/users/:id` lights up Users). ClientApp reuses it for the header title. Treasury is first
// because it is the home (2026-09-17), like the legacy "Manage Sila" page was.
export const NAV = [
  {
    key: 'treasury',
    path: '/treasury',
    label: 'Treasury',
    icon: <WalletOutlined />,
  },
  {
    key: 'properties',
    path: '/properties-and-investments',
    label: 'Properties & Investments',
    icon: <BankOutlined />,
  },
  {
    key: 'add-property',
    path: '/add-property',
    label: 'Add Property',
    icon: <PlusSquareOutlined />,
  },
  { key: 'users', path: '/users', label: 'Users', icon: <TeamOutlined /> },
  {
    key: 'investment-rules',
    path: '/investment-rules',
    label: 'Investment rules',
    icon: <SlidersOutlined />,
  },
];

export const activeNav = (pathname) =>
  NAV.find((item) => pathname.startsWith(item.path)) || NAV[0];

const MUTED = 'rgba(255, 255, 255, 0.65)';

// Brand on top, the menu, and the logged-in operator with Logout at the bottom. `operator` is
// `session.user` (may be null while the session query loads).
function Sidebar({ collapsed, operator }) {
  const history = useHistory();
  const location = useLocation();
  const active = activeNav(location.pathname);

  const logout = () => {
    store.clearAll();
    history.push('/login');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'flex-start',
          gap: 12,
          height: 64,
          padding: collapsed ? 0 : '0 24px',
          color: '#fff',
          borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
        }}
      >
        <BankOutlined style={{ fontSize: 24 }} />
        {!collapsed && (
          <div style={{ lineHeight: 1.2 }}>
            <div style={{ fontWeight: 600, fontSize: 15 }}>
              Constitution Lending
            </div>
            <div style={{ fontSize: 12, color: MUTED }}>Admin</div>
          </div>
        )}
      </div>

      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[active.key]}
        onClick={({ key }) =>
          history.push(NAV.find((item) => item.key === key).path)
        }
        items={NAV.map(({ key, label, icon }) => ({ key, label, icon }))}
        style={{ marginTop: 8 }}
      />

      <div
        style={{
          marginTop: 'auto',
          padding: collapsed ? '12px 0' : '12px 16px 16px',
          borderTop: '1px solid rgba(255, 255, 255, 0.12)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: collapsed ? 'center' : 'stretch',
          gap: 8,
        }}
      >
        {collapsed ? (
          <Tooltip placement="right" title={operator ? operator.email : ''}>
            <UserOutlined style={{ color: MUTED, fontSize: 18 }} />
          </Tooltip>
        ) : (
          <div style={{ color: MUTED, fontSize: 12, lineHeight: 1.4 }}>
            <div>Signed in as</div>
            <Typography.Text
              ellipsis={{ tooltip: operator ? operator.email : '' }}
              style={{ color: '#fff', display: 'block' }}
            >
              {operator ? operator.email : '…'}
            </Typography.Text>
          </div>
        )}
        <Tooltip placement="right" title={collapsed ? 'Logout' : ''}>
          <Button
            ghost
            size="small"
            icon={<LogoutOutlined />}
            onClick={logout}
            block={!collapsed}
          >
            {collapsed ? null : 'Logout'}
          </Button>
        </Tooltip>
      </div>
    </div>
  );
}

export default Sidebar;
